import AdvertisementCookie from "components/shared/AdvertisementCookie/AdvertisementCookie";
import GetGPT from "../GetGPT/GetGPT";

export default class GetPWT {
  static getPWTAndGPT() {
    if (AdvertisementCookie.showBannerAd()) {
      var pubmatic_id = window.location.hostname.match(/^m\./) ? "2473": "2472";
      window.PWT = {};
      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];
      window.gptRan = false;
      window.PWT.jsLoaded = GetPWT.jsLoadedFunction;
      window.setTimeout(GetPWT.loadGPT, 500);
      GetPWT.loadPWT(pubmatic_id)
    }
  }

  static jsLoadedFunction() {
    GetPWT.loadGPT();
  }

  static loadGPT() {
    if (!window.gptRan) {
      window.gptRan = true;
      GetGPT.loadGPT()
    }
  }

  static loadPWT(pubmatic_id) {
    // commented out because we're not likely to add pwtv query parameter in our url
    // var purl = window.location.href;
    var url = "https://ads.pubmatic.com/AdServer/js/pwt/157644/" + pubmatic_id;
    // var profileVersionId = "";
    // if (purl.indexOf("pwtv=") > 0) {
    //   var regexp = /pwtv=(.*?)(&|$)/g;
    //   var matches = regexp.exec(purl);
    //   if (matches.length >= 2 && matches[1].length > 0) {
    //     profileVersionId = "/" + matches[1];
    //   }
    // }
    var wtads = document.createElement("script");
    wtads.async = "async";
    wtads.type = "text/javascript";
    // wtads.src = url + profileVersionId + "/pwt.js";
    wtads.src = url + "/pwt.js";
    document.head.appendChild(wtads);
  }
}